import { useEffect, useRef } from 'react';

export function CursorGlow() {
  const ref = useRef<HTMLDivElement>(null);
  const rafRef = useRef(0);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(hover: none)').matches) return;

    const target = { x: window.innerWidth * 0.7, y: window.innerHeight * 0.3 };
    const current = { x: target.x, y: target.y };

    const onMove = (e: MouseEvent) => {
      target.x = e.clientX;
      target.y = e.clientY;
    };
    window.addEventListener('mousemove', onMove);

    const tick = () => {
      current.x += (target.x - current.x) * 0.1;
      current.y += (target.y - current.y) * 0.1;
      if (ref.current) {
        ref.current.style.transform = `translate3d(${current.x - 600}px, ${current.y - 600}px, 0)`;
      }
      rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);

    return () => {
      window.removeEventListener('mousemove', onMove);
      cancelAnimationFrame(rafRef.current);
    };
  }, []);

  const iw = typeof window !== 'undefined' ? window.innerWidth : 1200;
  const ih = typeof window !== 'undefined' ? window.innerHeight : 800;

  return (
    <div
      ref={ref}
      aria-hidden="true"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: 1200,
        height: 1200,
        pointerEvents: 'none',
        zIndex: 0,
        background:
          'radial-gradient(circle, var(--accent-glow) 0%, transparent 60%)',
        willChange: 'transform',
        transform: `translate3d(${iw * 0.7 - 600}px, ${ih * 0.3 - 600}px, 0)`,
      }}
    />
  );
}
